import { createContext } from "react";
import { SettingsLink } from "./useSettingsLinks";
import { SectionTab } from "@foodpilot/foods";

export type SettingsInitialValues = {
    allLinks: SettingsLink[];
    tabs: SectionTab[];
    selectedTabIndex: number | undefined;
};
export const SettingsContext = createContext<SettingsInitialValues | null>(null);
